import { AudioPinComponent, Vector } from '../../models';
import { stringToLeanProsemirror, emptyDocument } from '../../tip-tap';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type AudioSettingsProps = Omit<AudioPinComponent['settings'], 'title' | 'body'> & { title: string; body: string };

type AudioPinComponentProps = {
  position?: Vector;
  settings?: Partial<AudioSettingsProps>;
  diameter?: number;
  order?: string;
  rotation?: number;
  id?: string;
};

export function newAudioPinComponent({
  position = initialPinComponentPosition,
  settings = {},
  diameter = 75,
  order = defaultOrder,
  rotation,
  id,
}: AudioPinComponentProps): AudioPinComponent {
  return {
    type: 'AUDIO',
    id: id ?? randomId(),
    settings: {
      ...settings,
      fillType: settings.fillType ?? 'ICON',
      iconFill: settings.iconFill ?? 'AUDIO',
      imageFill: settings.imageFill ?? {
        name: 'demo-image.jpg',
        url: 'https://lh3.googleusercontent.com/QjsbtROFsiGYbXAtGymx8rQaasKbIQ9f1YwUEkJL8fWlmwafNHImcWL5ot-IYZuEaZfG85HQS5bJWufho0kpQmeGG2yodzOiKZ9GTKE=s800',
      },
      textFill: settings.textFill ?? 'ABC',
      expandDirection: settings.expandDirection ?? 'AUTO',
      movableInInteractiveViewer: settings.movableInInteractiveViewer,
      title: settings.title ? stringToLeanProsemirror(settings.title) : emptyDocument(),
      showBody: settings.showBody ?? false,
      body: settings.body ? stringToLeanProsemirror(settings.body) : emptyDocument(),
      contentTextColor: settings.contentTextColor,
      backgroundColor: settings.backgroundColor,
      borderColorProgress: settings.borderColorProgress,
      loop: settings.loop ?? false,
      audioUrl: settings.audioUrl,
      startTime: settings.startTime,
      endTime: settings.endTime,
      volume: settings.volume ?? 1,
    },
    layout: newBox(position, newSize(diameter, diameter), rotation, true),
    order,
  };
}
